// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IFolderSummaryState {
  name: string;
  fileCount: number;
  modified: Date;
}
